import { useEffect, useState, useRef } from "react";

export const useInView = (
  options: IntersectionObserverInit,
  triggerOnce: boolean
) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState<boolean>(false);
  const observerRef = useRef<IntersectionObserver>(null);

  useEffect(() => {
    if (!ref.current) return;

    observerRef.current = new IntersectionObserver(([entry]) => {
      setIsInView(entry.isIntersecting);
    }, options);

    observerRef.current?.observe(ref.current);

    return () => observerRef.current?.disconnect();
  }, [ref, options]);

  useEffect(() => {
    if (isInView && triggerOnce) {
      observerRef.current?.disconnect();
    }
  }, [isInView, triggerOnce]);

  return { ref, isInView };
};
